import { createContext } from 'react';
import { QUERY_KEYS_SAS, useChartsData } from '../../../../Common/hooks/useChartsData';
import { useIgdFiltersContext } from '../../../Common/Filters/hooks/useIgdFiltersContext';

export const IDCONSELHOChartsDataContext = createContext();

const normalizeSize = (value) => {
    if (!value) {
        return 'Não informado';
    }

    const sizeMap = {
        '1': 'Pequeno I',
        '2': 'Pequeno II',
        '3': 'Médio',
        '4': 'Grande',
    };

    return sizeMap[value] || value;
};

const IDCONSELHOChartsDataProvider = ({ children }) => {
    const { filters } = useIgdFiltersContext();

    const requestFilters = {
        year: filters?.year?.value ?? '',
        location: filters.unidade.value,
        city: filters.cidade?.value,
    };

    const generalQuery = useChartsData(
        {
            key: QUERY_KEYS_SAS.IDCONSELHO_GENERAL,
            url: 'governanceroom/socialdashboard/socialAssistanceSurveillance/idconselho/general',
        },
        requestFilters
    );

    const populationQuery = useChartsData(
        {
            key: QUERY_KEYS_SAS.IDCONSELHO_POPULATION,
            url: 'governanceroom/socialdashboard/socialAssistanceSurveillance/idconselho/population',
        },
        requestFilters
    );

    const sizeQuery = useChartsData(
        {
            key: QUERY_KEYS_SAS.IDCONSELHO_SIZE,
            url: 'governanceroom/socialdashboard/socialAssistanceSurveillance/idconselho/size',
        },
        requestFilters
    );

    const administrativeStructureQuery = useChartsData(
        {
            key: QUERY_KEYS_SAS.IDCONSELHO_ADMINISTRATIVE_STRUCTURE,
            url: 'governanceroom/socialdashboard/socialAssistanceSurveillance/idconselho/administrativeStructure',
        },
        requestFilters
    );

    const operatingDynamicsQuery = useChartsData(
        {
            key: QUERY_KEYS_SAS.IDCONSELHO_OPERATING_DYNAMICS,
            url: 'governanceroom/socialdashboard/socialAssistanceSurveillance/idconselho/operatingDynamics',
        },
        requestFilters
    );

    const councilCompositionQuery = useChartsData(
        {
            key: QUERY_KEYS_SAS.IDCONSELHO_COUNCIL_COMPOSITION,
            url: 'governanceroom/socialdashboard/socialAssistanceSurveillance/idconselho/councilComposition',
        },
        requestFilters
    );

    const chartData = {
        general:
            generalQuery.data?.anualEvolution?.map((item) => ({
                ...item,
                idconselho: item.idconselho ? Number(item.idconselho) : null,
            })) ?? [],

        population:
            populationQuery.data?.anualEvolution?.map((item) => ({
                ...item,
            })) ?? [],

        size:
            sizeQuery.data?.anualEvolution?.map((item) => ({
                ...item,
                porte: normalizeSize(item.porte),
            })) ?? [],

        administrativeStructure:
            administrativeStructureQuery.data?.anualEvolution?.map((item) => ({
                ...item,
                estrutura_administrativa: item.estrutura_administrativa
                    ? Number(item.estrutura_administrativa)
                    : null,
            })) ?? [],

        operatingDynamics:
            operatingDynamicsQuery.data?.anualEvolution?.map((item) => ({
                ...item,
                dinamica_funcionamento: item.dinamica_funcionamento
                    ? Number(item.dinamica_funcionamento)
                    : null,
            })) ?? [],

        councilComposition:
            councilCompositionQuery.data?.anualEvolution?.map((item) => ({
                ...item,
                composicao_conselho: item.composicao_conselho
                    ? Number(item.composicao_conselho)
                    : null,
            })) ?? [],
    };

    const isLoading =
        generalQuery.isLoading ||
        populationQuery.isLoading ||
        sizeQuery.isLoading ||
        administrativeStructureQuery.isLoading ||
        operatingDynamicsQuery.isLoading ||
        councilCompositionQuery.isLoading;

    const isError =
        generalQuery.isError ||
        populationQuery.isError ||
        sizeQuery.isError ||
        administrativeStructureQuery.isError ||
        operatingDynamicsQuery.isError ||
        councilCompositionQuery.isError;

    return (
        <IDCONSELHOChartsDataContext.Provider
            value={{
                chartData,
                filters,
                isLoading,
                isError,

                rawData: {
                    general: generalQuery.data,
                    population: populationQuery.data,
                    size: sizeQuery.data,
                    administrativeStructure: administrativeStructureQuery.data,
                    operatingDynamics: operatingDynamicsQuery.data,
                    councilComposition: councilCompositionQuery.data,
                },
            }}
        >
            {children}
        </IDCONSELHOChartsDataContext.Provider>
    );
};

export default IDCONSELHOChartsDataProvider;